import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import {
  OfferListResponse,
  QineticNegotiationApi,
} from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const getOffers = createAsyncThunk<OfferListResponse, void, ThunkApi>(
  "getOffers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await new QineticNegotiationApi().getOffers();

      return {
        offers: response.data.offers,
        offersAttempts: response.data.offersAttempts,
      };
    } catch (err: any) {
      pushErrorMonitor(err); //send error push monitor
      const error: LayoutError = {
        title: "Recupero offerte",
        description:
          "Non siamo riusciti a recuperare le tue offerte.\n Puoi riprovare o contattare il supporto",
        error: err.message,
      };
      return rejectWithValue(error);
    }
  },
);
